import {Component, Input} from '@angular/core';
import {AppointmentRequest} from '@shared/models/appointment-request.model';

@Component({
  selector: 'si-appo-appointment-request-finish',
  templateUrl: './appo-appointment-request-finish.component.html',
  styleUrls: ['./appo-appointment-request-finish.component.scss']
})
export class AppoAppointmentRequestFinishComponent {
  @Input() model = new AppointmentRequest();
}
